<template>
  <div class="page_zxzt">
    <div class="zxzt_banner"></div>
    <div class="tab">
      <div class="m">
        <div class="tab_l">
          <span :class="{active:params.sort==='SortDefault'}" @click="changeTAb('SortDefault')">精选推荐</span>
          <span :class="{active:params.sort==='SortPopularityDESC'}" @click="changeTAb('SortPopularityDESC')">最热展会</span>
        </div>
        <div class="tab_r">
          <el-select v-model="params.school" class="width240" placeholder="关联院校" @change="search" filterable>
             <el-option
              label="全部院校"
              value=""
            ></el-option>
            <el-option
              v-for="item in school"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input style="margin-left:20px;" class="width240" placeholder="请输入内容" v-model="params.name" @change="search">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <div class="page_zxzt_warp m">
      <zxzt :list="list" />
      <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
    </div>
  </div>
</template>

<script>
import zxzt from "@/components/list_item/zxzt/list";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    zxzt,
    myPage
  },
  data() {
    return {
      options: [],
      input4: "",
      value: "",
      params:{
        name:'',//名称
        school:'',//关联院校
        sort:'SortDefault',
        type_2020:true,//专项展厅
      },
      layerpageinfo: {
        pageSize: 12,
        pageNo: 0,
        total: 0
      },
     list: [],
     active:1,
     school:[],//学校列表
    };
  },
  created(){
    this.getSchool();
    this.getData();
  },
  methods:{
    search(){
      this.layerpageinfo =  Object.assign({},{
        pageSize: 12,
        pageNo: 0,
        total: 0
      });
      this.getData();
    },
    getData() {
      let params = Object.assign({},this.params,this.layerpageinfo,{
        status:'IdentityCertifieStatussuccess'
      });
      return new Promise(resolve => {
        this.api.getFrontExhibitions(params).then(res => {
          if (res.error["err_code"] !== 0) return;
          this.list = res.obj.list || [];
          this.layerpageinfo.total = res.obj.totalSize;
          resolve();
        });
      });
    },
    changeTAb(num){
      this.params.sort = num;
      this.search();
    },
    //查询学校列表
    getSchool(){
      let params = {
        pageSize:998,
        is_2020:true
      }
      this.api.getSchoolsList(params).then(res=>{
        if (res.error.err_code !== 0) return;
        this.school = res.obj.list;
      })
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getData();
    },
  }
};
</script>

<style lang="scss" scoped>
.page_zxzt {
  .zxzt_banner {
    height: 400px;
    background: url("~@/assets/img/newhome/b2.jpg") no-repeat center;
    background-size: cover;
  }
  .tab {
    background: #fff;
    .m {
      display: flex;
      justify-content: space-between;
      height: 80px;
      align-items: center;
      .tab_l {
        display: flex;
        span {
          font-size: 16px;
          color: #999;
          margin-right: 70px;
          position: relative;
          cursor:pointer;
        }
        span.active {
          color: #333;
        }
        span.active::after {
          content: "";
          position: absolute;
          bottom: -30px;
          width: 29px;
          height: 3px;
          background: #111111;
          left: 0;
          right: 0;
          margin:0 auto;
        }
      }
      .tab_r {
        display: flex;
      }
    }
  }
  .width240{
    width: 240px;
  }
  .page_zxzt_warp{
    padding: 40px 0;
  }
}
</style>